import React, { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';
import { computeTurkeyForumIndex } from '../../utils/turkeyForumIndex';
import type { ForumBase } from '../../types/forum';

/** Yazdır → PDF olarak kaydet */
const AdminReportPage: React.FC = () => {
  const [forums, setForums] = useState<ForumBase[]>([]);

  useEffect(() => {
    supabase.from('forums').select('*').eq('is_active', true).then(({ data }) => setForums(data || []));
  }, []);

  const tfe = computeTurkeyForumIndex(forums);
  const month = new Date().toLocaleDateString('tr-TR', { month: 'long', year: 'numeric' });

  return (
    <div className="p-8 max-w-3xl mx-auto text-gray-900 print:p-12">
      <h1 className="text-2xl font-bold">Kitapçık — Aylık rapor</h1>
      <p className="text-gray-600 mt-2">{month}</p>
      <section className="mt-8">
        <h2 className="text-lg font-semibold">Türkiye Forum Endeksi</h2>
        <p className="text-4xl font-bold text-indigo-700 mt-2">{tfe.index}</p>
        <p>Aktif forum: {tfe.activeCount} · Toplam üye: {tfe.totalMembers.toLocaleString('tr-TR')}</p>
      </section>
      <section className="mt-8">
        <h2 className="text-lg font-semibold">Özet</h2>
        <p>Bu rapor tarayıcıdan yazdırılarak PDF olarak saklanabilir.</p>
      </section>
      <button
        type="button"
        onClick={() => window.print()}
        className="mt-8 print:hidden px-4 py-2 bg-indigo-600 text-white rounded-lg"
      >
        Yazdır / PDF
      </button>
    </div>
  );
};

export default AdminReportPage;
